import type { SuiValidatorSummary } from '@mysten/sui.js/client';

export function compareStakeDesc(a: string | bigint, b: string | bigint): number {
	const da = BigInt(a);
	const db = BigInt(b);
	if (da > db) return -1;
	if (da < db) return 1;
	return 0;
}

export function sortValidatorsByStake(
	validators: SuiValidatorSummary[],
): SuiValidatorSummary[] {
	return [...validators].sort((a, b) =>
		compareStakeDesc(a.stakingPoolSuiBalance, b.stakingPoolSuiBalance),
	);
}
